import React from 'react'
import "./UserProfile.css";
import ProfileSidebar from './ProfileSidebar';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PROJECT_DISPLAY_NAME } from '../../../config/apiConfig';


export default function SelectCompany() {
  return (
    <div className='user_profile_wrapper pt-4 pb-4'>
      <div className='container'>
        <div className='user_profile_subblock'>
          <div className='row'>
          <div className='client_head_left'><h5 className="client_head">Client Admin Login</h5></div>

              <div className='col-md-3'>
                  <div className='sidebar_profile'>
                    <ProfileSidebar/>
                  </div>
              </div>
              <div className='col-md-9'>
                <div className='userprofile_right'>
                  <div className='col-md-12'>
                
                  <Form name="information" className="user_form_info">
                      <div className='row'>
                     
                        <div className='col-md-12'>
                          <div className='selected_bu border_none'>
                            <h5 className='bu_select_head'>Select the companies to be created for {PROJECT_DISPLAY_NAME}</h5>
                            <div className='col-md-6'>
                              <div className="form-control-info">
                                <Form.Select aria-label="Default select example" className='custom_info_select form-input'>
                                  <option value="1">Northrop Grumman</option>
                                  <option value="2">Northrop Grumman 1</option>
                                  <option value="3">Northrop Grumman 2</option>
                                </Form.Select>
                                <label for="text" className="form-label">Search and add the companies </label>
                                </div>
                             </div>
                 
                            <div className="row">
                            <h5 className='bu_select_head'>Selected companies</h5>

                              <div className='selected_company_list'>
                                <div className='selectded_compbu_list'>
                                  <p className='bu'><span className='bu_selected'>Commercial </span><a href="#" className='close_bu'><img src="/img/icons/profile/close.png" className="fa" /></a></p>
                                </div>
                                <div className='selectded_compbu_list'>
                                  <p className='bu'><span className='bu_selected'>Commercial </span><a href="#" className='close_bu'><img src="/img/icons/profile/close.png" className="fa" /></a></p>
                                </div>
                                <div className='selectded_compbu_list'>
                                  <p className='bu'><span className='bu_selected'>Commercial </span><a href="#" className='close_bu'><img src="/img/icons/profile/close.png" className="fa" /></a></p>
                                </div>
                              </div>
                           
                            </div>

                       

                          </div>
                        </div>
                      </div>
                  
              


                     

                          <div className='col-md-12 mt-4'>
                          <div className='prev_next_block'>
                            <Button className="previous_btn">
                              Back
                            </Button>
                            <Button className="next_btn_blue">
                              Next
                            </Button>
                          </div>
                        </div>     
                    </Form>
                  </div>
                </div>  
              </div>  
          </div>      
        </div>
      </div>
    </div>
  )
}
